import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { User, CreditCard, Settings } from 'lucide-react';
import { ROUTES } from '@/utils/constants';

const MyAccount: React.FC = () => {


  const accountSections = [
    {
      title: 'Profile',
      description: 'Manage your personal information and preferences',
      icon: User,
      href: '/my-account/profile',
      color: 'bg-blue-50 text-blue-600',
    },
    {
      title: 'My Subscriptions',
      description: 'Manage your active and past service subscriptions',
      icon: CreditCard,
      href: ROUTES.MY_SUBSCRIPTIONS,
      color: 'bg-green-50 text-green-600',
    },
    {
      title: 'Account Settings',
      description: 'Update your security and notification settings',
      icon: Settings,
      href: '/my-account/settings',
      color: 'bg-gray-50 text-gray-600',
    },
  ];

  return (
    <div className="space-y-8">
      {/* Page Header */}
      <div className="space-y-2">
        <h1 className="text-4xl font-bold text-gray-900">My Account</h1>
        <p className="text-lg text-gray-600">
          Manage your profile, subscriptions, and account settings.
        </p>
      </div>

      {/* Account Sections */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {accountSections.map((section) => {
          const Icon = section.icon;
          return (
            <Card key={section.href} className="p-6 hover:shadow-md transition-shadow">
              <div className="space-y-4">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${section.color}`}>
                  <Icon className="w-6 h-6" />
                </div>

                <div className="space-y-2">
                  <h3 className="text-lg font-semibold text-gray-900">{section.title}</h3>
                  <p className="text-sm text-gray-600">{section.description}</p>
                </div>

                <Button asChild className="w-full">
                  <Link to={section.href}>
                    Go to {section.title}
                  </Link>
                </Button>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default MyAccount;
